import { render } from "./GoalSection.vue?vue&type=template&id=57dff247&scoped=true"
import script from "./GoalSection.vue?vue&type=script&lang=js"
export * from "./GoalSection.vue?vue&type=script&lang=js"

import "./GoalSection.vue?vue&type=style&index=0&id=57dff247&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57dff247"]])

export default __exports__